import { saveComprehensionResponse, onQuestionChange, resetPagesViewed } from '../../trcActions';
import selectors from '../../../rootSelectors';
import {
    setConfirmPopupVisibility,
    setShouldDisplayCaption,
} from '../../../common/screen/screenActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { goToQuestion } from '../../../common/navigation/navigationActions';
import { TRC } from '../../../constants/measure';
import { getTrcInstruction, getTrcCaption } from '../../troConstants';
import { startQuestionTimeTracking } from '../../../common/timeTracking/timeTrackingActions';
import { stopAudio, setCaption } from '../../../common/audio/audioActions';
import { setAlexState } from '../../../common/alex/AlexActions';
import AlexStates from '../../../common/alex/AlexStates';

const comprehensionCompleteReminderInsctruction = 'comprehensionCompleteReminder';

const onNextButtonClick = questionIndex => (dispatch, getStore) => {
    const state = getStore();
    const isLastQuestion = questionIndex + 1 === selectors.getNumTRCComprehensionItems(state);
    const isExternalURLSourcePresent = selectors.getExternalURLSourceStatus(state);
    const arLanguage = selectors.getArLanguage(state);

    if (isLastQuestion) {
        const audio = getTrcInstruction(
            isExternalURLSourcePresent,
            comprehensionCompleteReminderInsctruction,
            arLanguage,
        );
        const caption = getTrcCaption(
            isExternalURLSourcePresent,
            comprehensionCompleteReminderInsctruction,
            arLanguage,
        );
        if (isExternalURLSourcePresent) {
            dispatch(stopAudio());
            dispatch(setAlexState(AlexStates.INACTIVE));
            dispatch(setCaption(caption));
            dispatch(setShouldDisplayCaption(true));
        }
        dispatch(setConfirmPopupVisibility(true));
        dispatch(setAvatarInstructions(audio));
        return dispatch(playAvatarAudio(audio)).then(() => {
            if (isExternalURLSourcePresent) {
                dispatch(setShouldDisplayCaption(false));
            }
        });
    }

    return dispatch(saveComprehensionResponse(questionIndex)).then(() => {
        const nextQuestionIndex = questionIndex + 1;
        const nextQuestion = nextQuestionIndex + 1;

        dispatch(onQuestionChange(nextQuestionIndex));
        dispatch(goToQuestion(TRC, null, nextQuestion));
        dispatch(startQuestionTimeTracking());
        dispatch(resetPagesViewed());
    });
};

export default onNextButtonClick;
